/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from "react";
// @mui material components
import { Link } from "react-router-dom";
// Material Dashboard 2 React components
import {
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const CRUDChangePassword = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  validationErrors,
}) => {
  const [errors, setErrors] = useState({
    password: "",
    repassword: "",
  });
  const formRef = useRef(null);
  const [values, setValues] = useState({
    showPass: false,
  });
  const [revalues, setReValues] = useState({
    showPass: false,
  });
  async function onSubmitForm(event) {
    event.preventDefault();
    const form = formRef.current;
    const formData = new FormData(form);
    const _data = {};
    formData.forEach((value, key) => {
      if (!_data[key]) {
        _data[key] = key === "picture" ? [value] : value;
      } else {
        _data[key].push(value);
      }
    });
    _data["username"] = data?.username;
    _data["rowIndex"] = data?.rowIndex;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    if (checkconfirmpassword(_data["password"], _data["repassword"])) {
      setErrors({
        ...errors,
        repassword: "Mật khẩu không khớp",
      });
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    setErrors(validationErrors);
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setReValues(false);
      setValues(false);
      setErrors([]);
    }
  }, [open]);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  const handleRePassVisibilty = () => {
    setReValues({
      ...revalues,
      showPass: !revalues.showPass,
    });
  };
  return (
    <Dialog open={open} maxWidth={"md"}>
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Thay đổi mật khẩu Tài khoản người dùng"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  disabled
                  name="username"
                  label="Tài khoản"
                  defaultValue={data ? data.username : ""}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  type={values.showPass ? "text" : "password"}
                  name="password"
                  label="Mật khẩu"
                  error={errors ? !!errors.password : false}
                  helperText={errors?.password}
                  // defaultValue={data ? data.password : ""}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      password: "",
                    });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handlePassVisibilty}
                          aria-label="toggle password"
                          edge="end"
                        >
                          {values.showPass ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  type={revalues.showPass ? "text" : "password"}
                  name="repassword"
                  label="Xác nhận mật khẩu"
                  error={errors ? !!errors.repassword : false}
                  helperText={errors?.repassword}
                  // defaultValue={data ? data.password : ""}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      repassword: "",
                    });
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleRePassVisibilty}
                          aria-label="toggle password"
                          edge="end"
                        >
                          {revalues.showPass ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    password: !validateRequired(user.password)
      ? "Mật khẩu không được trống"
      : "",
    repassword: !validateRequired(user.repassword)
      ? "Xác nhận mật khẩu không được trống"
      : "",
  };
}

const checkconfirmpassword = (value, value1) => {
  let valid = false;
  if (value !== value1) {
    valid = true;
  }
  return valid;
};

export default CRUDChangePassword;
